import { render, staticRenderFns } from "./ScrollLink.vue?vue&type=template&id=72d61129"
import script from "./ScrollLink.vue?vue&type=script&lang=js"
export * from "./ScrollLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports